export default function decorate(router) {
  router.afterEach((to, from) => {
    // @ts-ignore
    if (window.analytics) window.analytics.page(to.name);
  });
}
